module.exports = __webpack_public_path__ + "static/img/logo.10c6019f.svg";